import React from "react";
import { plagiarismContext } from "./PlagiarismMain";
import { useContext } from "react";

function PlagiarismDetectorResult() {
  //get plagiarism detector values
  const { plagiarismDetectorValues, detectorResultSectionRef } =
    useContext(plagiarismContext);

  return (
    <div
      className={`container mt-5 ${
        plagiarismDetectorValues.isLoaded ? "" : "d-none"
      }`}
      ref={detectorResultSectionRef}
      id="plagiarism_detector_result"
    >
      <div className="shadow p-4">
        {/*Result title*/}
        <h4 className="mt-2 text-center text-primary">
          Plagiarism Checker Result
        </h4>

        {/*Text Original*/}
        <p className="lead mt-5 text-center">{plagiarismDetectorValues.text}</p>

        <div className="row justify-content-center mt-2">
          {/* Copied */}
          <div className="col-md-5 bg-light p-3 mt-5 py-4 rounded">
            {/* Copied Content */}
            <h4 className="text-muted fs-5">
              Copied Content:{" "}
              <span className="text-danger">
                {((1 - plagiarismDetectorValues.probability) * 100).toFixed(2)}%
              </span>
            </h4>
            {/* Progress bar */}
            <div className="progress mt-4">
              <div
                className="progress-bar progress-bar-striped bg-danger"
                role="progressbar"
                style={{
                  width: `${(1 - plagiarismDetectorValues.probability) * 100}%`,
                }}
                aria-valuenow={(1 - plagiarismDetectorValues.probability) * 100}
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>

          {/* Original */}
          <div className="col-md-5 bg-light p-3 mt-5 py-4 ms-4 rounded">
            {/* Original Content */}
            <h4 className="text-muted fs-5">
              Original Content:{" "}
              <span className="text-success">
                {(plagiarismDetectorValues.probability * 100).toFixed(2)}%
              </span>
            </h4>
            {/* Progress bar */}
            <div className="progress mt-4">
              <div
                className="progress-bar progress-bar-striped bg-success"
                role="progressbar"
                style={{
                  width: `${plagiarismDetectorValues.probability * 100}%`,
                }}
                aria-valuenow={plagiarismDetectorValues.probability * 100}
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
        </div>

        <p className="lead text-muted mt-5 fs-6 text-center">
          Note: Our Plagiarism checker identifies contents that may have been
          copied from other sources, using artificial intelligence. Use your own
          judgment when interpreting the results, and never rely solely on
          Plagiarism detectors to make decisions that could affect someone's
          academic or professional future.
        </p>
      </div>
    </div>
  );
}

export default PlagiarismDetectorResult;
